import React from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords = "ADHD productivity, Notion templates, creator tools, workflow optimization, Etsy SEO",
  canonical, 
  ogType = 'website', 
  ogImage = 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvcG5n/1cf231edd32513ef9fe10bfcd9b6359e.png' 
}) => {
  const siteTitle = "AlienProduction";
  const fullTitle = `${title} | ${siteTitle}`;
  const siteUrl = "https://alienproduction.store";

  React.useEffect(() => {
    document.title = fullTitle;
    
    // Update basic meta
    const updateMeta = (name, content, attr = 'name') => {
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    updateMeta('description', description);
    updateMeta('keywords', keywords);
    
    // Update OG tags
    updateMeta('og:title', fullTitle, 'property');
    updateMeta('og:description', description, 'property');
    updateMeta('og:image', ogImage, 'property');
    updateMeta('og:url', `${siteUrl}${canonical || ''}`, 'property');
    updateMeta('og:type', ogType, 'property');

    // Update Twitter tags
    updateMeta('twitter:title', fullTitle);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', ogImage);

    // Update Canonical link
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `${siteUrl}${canonical || ''}`);

  }, [fullTitle, description, keywords, ogImage, canonical, ogType]);

  return null;
};

export default SEO;